module.exports = __webpack_public_path__ + "static/media/public-icon.0e257ce3.svg";